'use strict';

var cov_98dm1rmmn = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/ui/ActivityIndicator/lib/ActivityIndicator.js',
      hash = '2f9f099c89f31493b16e979734bf7fb7c0787db7',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/ui/ActivityIndicator/lib/ActivityIndicator.js',
    statementMap: {
      '0': {
        start: {
          line: 5,
          column: 14
        },
        end: {
          line: 14,
          column: 1
        }
      },
      '1': {
        start: {
          line: 16,
          column: 16
        },
        end: {
          line: 28,
          column: 1
        }
      },
      '2': {
        start: {
          line: 30,
          column: 15
        },
        end: {
          line: 34,
          column: 1
        }
      },
      '3': {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 33,
          column: 35
        }
      },
      '4': {
        start: {
          line: 42,
          column: 26
        },
        end: {
          line: 48,
          column: 1
        }
      },
      '5': {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 47,
          column: 12
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 31,
            column: 10
          },
          end: {
            line: 31,
            column: 11
          }
        },
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 33,
            column: 35
          }
        },
        line: 32
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 42,
            column: 26
          },
          end: {
            line: 42,
            column: 27
          }
        },
        loc: {
          start: {
            line: 43,
            column: 2
          },
          end: {
            line: 47,
            column: 12
          }
        },
        line: 43
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 33,
            column: 35
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 32,
            column: 5
          },
          end: {
            line: 32,
            column: 16
          }
        }, {
          start: {
            line: 32,
            column: 20
          },
          end: {
            line: 32,
            column: 49
          }
        }, {
          start: {
            line: 32,
            column: 53
          },
          end: {
            line: 32,
            column: 88
          }
        }, {
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 33,
            column: 35
          }
        }],
        line: 32
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0
    },
    f: {
      '0': 0,
      '1': 0
    },
    b: {
      '0': [0, 0, 0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  0% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n'], ['\n  0% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  position: relative;\n  transform: translateZ(0);\n  display: inline-block;\n  vertical-align: middle;\n\n  height: 1.5em;\n  width: 1.5em;\n\n  animation: ', ' 1s infinite linear;\n'], ['\n  position: relative;\n  transform: translateZ(0);\n  display: inline-block;\n  vertical-align: middle;\n\n  height: 1.5em;\n  width: 1.5em;\n\n  animation: ', ' 1s infinite linear;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  fill: ', ';\n'], ['\n  fill: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _stylingConstants = require('@gravity/styling-constants');

var _stylingConstants2 = _interopRequireDefault(_stylingConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pulse = (cov_98dm1rmmn.s[0]++, (0, _styledComponents.keyframes)(_templateObject));

var Wrapper = (cov_98dm1rmmn.s[1]++, _styledComponents2.default.div.attrs({
  className: 'g-ActivityIndicator'
})(_templateObject2, pulse));
// create the circle object to ensure that the style is applied
var Circle = (cov_98dm1rmmn.s[2]++, _styledComponents2.default.circle(_templateObject3, function (props) {
  cov_98dm1rmmn.f[0]++;
  cov_98dm1rmmn.s[3]++;
  return (cov_98dm1rmmn.b[0][0]++, props.theme) && (cov_98dm1rmmn.b[0][1]++, props.theme.activityIndicator) && (cov_98dm1rmmn.b[0][2]++, props.theme.activityIndicator.color) || (cov_98dm1rmmn.b[0][3]++, _stylingConstants2.default.color.baseText);
}));

/** This component is used to show that things are loading. It shows a cicrle that may pulse or rotate.
  Theming value :
    theme.activityIndicator : {
    color
  }
*/
cov_98dm1rmmn.s[4]++;
var ActivityIndicator = function ActivityIndicator(props) {
  cov_98dm1rmmn.f[1]++;
  cov_98dm1rmmn.s[5]++;
  return _react2.default.createElement(
    Wrapper,
    (0, _extends3.default)({ role: 'progressbar', 'aria-valuemin': '0', 'aria-valuemax': '1' }, props),
    _react2.default.createElement(
      'svg',
      { height: '100%', viewBox: '0 0 32 32', width: '100%' },
      _react2.default.createElement(Circle, { cx: '16', cy: '16', r: '16' })
    )
  );
};

exports.default = ActivityIndicator;